import { SegmentFragment, CheckinSegmentFragment } from '@websky/graphql';
import { CartGroupOptionAdapterType } from '../../../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import { ServiceOptionItem } from '../../../../ServiceSummary/types';
import { TravellerInfo } from '../../../../types';
import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';

export const groupServiceOptionsBySegment = ({
	items,
	segments,
	traveller
}: {
	items: ServiceOptionItem[];
	segments: (SegmentFragment | CheckinSegmentFragment)[];
	traveller: TravellerInfo;
}): CartGroupOptionAdapterType[] => {
	const itemsBySegmentMap = new Map<string, ServiceOptionItem[]>();

	items.forEach(item => {
		const key = item.segment;

		itemsBySegmentMap.set(key, [...(itemsBySegmentMap.get(key) ?? []), item]);
	});

	return [...itemsBySegmentMap.entries()].map(([key, items]) => {
		const isAllSegments = key === ALL_SEGMENTS_KEY;
		const direction = !isAllSegments ? segments.find(segment => segment.id === key) : null;

		return {
			items,
			traveller,
			headerType: 'travellerName',
			direction: direction,
			allSegments: isAllSegments
		};
	});
};
